import {
    SUPPORT_HELMET_TITLE,
    SUPPORT_HELMET_DESCRIPTION,
    SUPPORT_HERO_EYEBROW,
    SUPPORT_HERO_TITLE,
    SUPPORT_HERO_SUBTITLE,
    SUPPORT_HERO_CTA_PRIMARY,
    SUPPORT_HERO_CTA_SECONDARY,
    SUPPORT_HERO_RESPONSE_TIME,
    SUPPORT_CHANNELS_EYEBROW,
    SUPPORT_CHANNELS_TITLE,
    SUPPORT_CHANNELS_SUBTITLE,
    SUPPORT_CHANNEL_PHONE_TITLE,
    SUPPORT_CHANNEL_PHONE_DESC,
    SUPPORT_CHANNEL_PHONE_CTA,
    SUPPORT_CHANNEL_WHATSAPP_TITLE,
    SUPPORT_CHANNEL_WHATSAPP_DESC,
    SUPPORT_CHANNEL_WHATSAPP_CTA,
    SUPPORT_CHANNEL_EMAIL_TITLE,
    SUPPORT_CHANNEL_EMAIL_DESC,
    SUPPORT_CHANNEL_EMAIL_CTA,
    SUPPORT_CHANNEL_VISIT_TITLE,
    SUPPORT_CHANNEL_VISIT_DESC,
    SUPPORT_CHANNEL_VISIT_CTA,
    SUPPORT_FORM_EYEBROW,
    SUPPORT_FORM_TITLE,
    SUPPORT_FORM_SUBTITLE,
    SUPPORT_FORM_NAME_LABEL,
    SUPPORT_FORM_NAME_PLACEHOLDER,
    SUPPORT_FORM_EMAIL_LABEL,
    SUPPORT_FORM_EMAIL_PLACEHOLDER,
    SUPPORT_FORM_PHONE_LABEL,
    SUPPORT_FORM_PHONE_PLACEHOLDER,
    SUPPORT_FORM_TOPIC_LABEL,
    SUPPORT_FORM_TOPIC_GENERAL,
    SUPPORT_FORM_TOPIC_CREDIT,
    SUPPORT_FORM_TOPIC_TAXES,
    SUPPORT_FORM_TOPIC_IMMIGRATION,
    SUPPORT_FORM_TOPIC_INSURANCE,
    SUPPORT_FORM_TOPIC_TRAVEL,
    SUPPORT_FORM_TOPIC_OTHER,
    SUPPORT_FORM_MESSAGE_LABEL,
    SUPPORT_FORM_MESSAGE_PLACEHOLDER,
    SUPPORT_FORM_CONSENT,
    SUPPORT_FORM_SUBMIT,
    SUPPORT_FORM_REQUIRED,
    SUPPORT_FORM_INVALID_EMAIL,
    SUPPORT_FORM_SUCCESS_TITLE,
    SUPPORT_FORM_SUCCESS_DESC,
    SUPPORT_FAQ_EYEBROW,
    SUPPORT_FAQ_TITLE,
    SUPPORT_FAQ_SUBTITLE,
    SUPPORT_FAQ_Q1, SUPPORT_FAQ_A1,
    SUPPORT_FAQ_Q2, SUPPORT_FAQ_A2,
    SUPPORT_FAQ_Q3, SUPPORT_FAQ_A3,
    SUPPORT_FAQ_Q4, SUPPORT_FAQ_A4,
    SUPPORT_FAQ_Q5, SUPPORT_FAQ_A5,
    SUPPORT_FAQ_Q6, SUPPORT_FAQ_A6,
} from "../types";

const en_support_page = {
    helmet: {
        [SUPPORT_HELMET_TITLE]: "Support & Contact — Linares Professional Family Services",
        [SUPPORT_HELMET_DESCRIPTION]: "Need help? Call, message or visit our Miami Lakes office. Our bilingual team typically responds within one business hour.",
    },
    section: {
        hero: {
            [SUPPORT_HERO_EYEBROW]: "We're here to help",
            [SUPPORT_HERO_TITLE]: "Real support, from real people.",
            [SUPPORT_HERO_SUBTITLE]: "Whether you have a question about your case, a tax document, or you just want to book a consultation — our bilingual team is one click away.",
            [SUPPORT_HERO_CTA_PRIMARY]: "Send us a message",
            [SUPPORT_HERO_CTA_SECONDARY]: "Call the office",
            [SUPPORT_HERO_RESPONSE_TIME]: "Average response time: under 1 business hour",
        },
        channels: {
            [SUPPORT_CHANNELS_EYEBROW]: "Reach us your way",
            [SUPPORT_CHANNELS_TITLE]: "Pick the channel that works for you",
            [SUPPORT_CHANNELS_SUBTITLE]: "Every channel is monitored by a real team member during business hours. No bots, no menus.",
            [SUPPORT_CHANNEL_PHONE_TITLE]: "Call us",
            [SUPPORT_CHANNEL_PHONE_DESC]: "Talk to a bilingual agent during business hours. Walk-ins also welcome.",
            [SUPPORT_CHANNEL_PHONE_CTA]: "Call now",
            [SUPPORT_CHANNEL_WHATSAPP_TITLE]: "WhatsApp",
            [SUPPORT_CHANNEL_WHATSAPP_DESC]: "Fastest way to send documents, photos, or quick questions on the go.",
            [SUPPORT_CHANNEL_WHATSAPP_CTA]: "Chat on WhatsApp",
            [SUPPORT_CHANNEL_EMAIL_TITLE]: "Email",
            [SUPPORT_CHANNEL_EMAIL_DESC]: "Best for longer requests, attachments, or sensitive documentation.",
            [SUPPORT_CHANNEL_EMAIL_CTA]: "Send an email",
            [SUPPORT_CHANNEL_VISIT_TITLE]: "Visit us",
            [SUPPORT_CHANNEL_VISIT_DESC]: "Stop by our Miami Lakes office. Walk-ins welcome during business hours.",
            [SUPPORT_CHANNEL_VISIT_CTA]: "Get directions",
        },
        form: {
            [SUPPORT_FORM_EYEBROW]: "Contact form",
            [SUPPORT_FORM_TITLE]: "Tell us how we can help",
            [SUPPORT_FORM_SUBTITLE]: "Fill in the form and a team member will get back to you, usually within one business hour.",
            [SUPPORT_FORM_NAME_LABEL]: "Full name",
            [SUPPORT_FORM_NAME_PLACEHOLDER]: "Jane Doe",
            [SUPPORT_FORM_EMAIL_LABEL]: "Email address",
            [SUPPORT_FORM_EMAIL_PLACEHOLDER]: "you@example.com",
            [SUPPORT_FORM_PHONE_LABEL]: "Phone (optional)",
            [SUPPORT_FORM_PHONE_PLACEHOLDER]: "(305) 555-0100",
            [SUPPORT_FORM_TOPIC_LABEL]: "What can we help with?",
            [SUPPORT_FORM_TOPIC_GENERAL]: "General question",
            [SUPPORT_FORM_TOPIC_CREDIT]: "Credit education & coaching",
            [SUPPORT_FORM_TOPIC_TAXES]: "Tax preparation",
            [SUPPORT_FORM_TOPIC_IMMIGRATION]: "Immigration services",
            [SUPPORT_FORM_TOPIC_INSURANCE]: "Insurance services",
            [SUPPORT_FORM_TOPIC_TRAVEL]: "Travel agency",
            [SUPPORT_FORM_TOPIC_OTHER]: "Other",
            [SUPPORT_FORM_MESSAGE_LABEL]: "Your message",
            [SUPPORT_FORM_MESSAGE_PLACEHOLDER]: "Tell us a little about what you're looking for…",
            [SUPPORT_FORM_CONSENT]: "I agree to be contacted by Linares Professional Family Services about my request.",
            [SUPPORT_FORM_SUBMIT]: "Send message",
            [SUPPORT_FORM_REQUIRED]: "This field is required",
            [SUPPORT_FORM_INVALID_EMAIL]: "Please enter a valid email address",
            [SUPPORT_FORM_SUCCESS_TITLE]: "Thanks — your message is on its way",
            [SUPPORT_FORM_SUCCESS_DESC]: "Your email app should open with your message ready to send. If it doesn't, please call or WhatsApp us using the buttons above.",
        },
        faq: {
            [SUPPORT_FAQ_EYEBROW]: "Frequently asked",
            [SUPPORT_FAQ_TITLE]: "Quick answers to common questions",
            [SUPPORT_FAQ_SUBTITLE]: "Can't find your answer? Send us a message — we usually reply within one business hour.",
            [SUPPORT_FAQ_Q1]: "Do I need an appointment to come in?",
            [SUPPORT_FAQ_A1]: "Walk-ins are welcome during business hours, but booking ahead guarantees you a dedicated time slot with the right specialist for your case.",
            [SUPPORT_FAQ_Q2]: "Are consultations really free?",
            [SUPPORT_FAQ_A2]: "Yes. Your first consultation for any of our services is completely free — we'll review your situation and explain your options with no obligation.",
            [SUPPORT_FAQ_Q3]: "What languages does your team speak?",
            [SUPPORT_FAQ_A3]: "Our entire team is fully bilingual in English and Spanish. You can call, write, or visit in either language.",
            [SUPPORT_FAQ_Q4]: "How long does credit coaching typically take?",
            [SUPPORT_FAQ_A4]: "Most clients see meaningful score improvements within 60–120 days, though every credit file is different. We'll give you a realistic timeline during your consultation.",
            [SUPPORT_FAQ_Q5]: "Can you handle my taxes if I live outside Miami?",
            [SUPPORT_FAQ_A5]: "Absolutely. We work with clients across the United States — documents can be sent securely by email, WhatsApp, or our client portal.",
            [SUPPORT_FAQ_Q6]: "Is my information kept confidential?",
            [SUPPORT_FAQ_A6]: "Always. Every document and conversation is protected by strict client-confidentiality policies. We only share information with third parties (like the IRS or USCIS) when you authorize it.",
        },
    },
};

export default en_support_page;
